import Text from 'UIKit/Text'
import { TextProps } from 'UIKit/Text/types'
import { InfoReward } from 'config/types/bonus/WagerAdventure'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { buildBonusName } from 'views/BonusCenter/hooks'

const BonusNameDisplay: React.FC<{ reward: InfoReward } & TextProps> = ({ reward, ...props }) => {
  const { t } = useTranslation()
  return (
    <Text lineHeight={'normal'} wordBreak="break-word" {...props}>
      {buildBonusName(t, reward.bonus?.info?.name)?.[0] || ''}
    </Text>
  )
}

export default BonusNameDisplay
